import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/edit-pencil-technical.svg'
import _imports_1 from '@/assets/add-plus-circle-grey.svg'
import _imports_2 from '@/assets/warning-red-rounded.svg'


const _hoisted_1 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_2 = { class: "w-full border border-[#E3E1EA] p-2 rounded-primary-radius flex items-center gap-2" }
const _hoisted_3 = { class: "w-[34px] h-[34px] flex items-center justify-center rounded-full bg-[#E8E7FB]" }
const _hoisted_4 = { class: "w-full border border-[#E3E1EA] p-2 rounded-primary-radius flex items-center gap-2" }
const _hoisted_5 = { class: "w-[34px] h-[34px] flex items-center justify-center rounded-full bg-[#E8E7FB]" }
const _hoisted_6 = { class: "mt-2" }
const _hoisted_7 = { class: "w-full border border-[#E3E1EA] p-2 rounded-primary-radius" }
const _hoisted_8 = { class: "w-full flex items-center gap-2" }
const _hoisted_9 = { class: "w-[34px] h-[34px] flex items-center justify-center rounded-full bg-[#E8E7FB]" }
const _hoisted_10 = { class: "h-[102px] overflow-y-auto mt-[10px]" }
const _hoisted_11 = { class: "flex flex-col gap-2" }
const _hoisted_12 = {
  key: 0,
  class: "flex flex-col gap-2"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["placeholder", "value"]
const _hoisted_15 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_16 = {
  key: 1,
  class: "flex items-center justify-center"
}
const _hoisted_17 = {
  key: 0,
  class: "flex items-center gap-1 mt-1 hover:cursor-pointer"
}

import { BauabschnittDetail } from "@/types";
import { computed } from "vue";

type Props = {
  strings: number | null | undefined;
  moduleFields: number | null | undefined;
  bauabschnitt: number | null | undefined;
  bauabschnittDetails: BauabschnittDetail[] | null | undefined;
};

type Emits = {
  (event: "openModal", input: any): void;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'TechnicalDetailsInputsBlock',
  props: {
    strings: {},
    moduleFields: {},
    bauabschnitt: {},
    bauabschnittDetails: {}
  },
  emits: ["openModal"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;

const onOpenModal = (input: any) => {
  emits("openModal", input);
};

let inputs = computed(() => {
  let tempInputs = [];
  if (props.bauabschnitt) {
    for (let index = 0; index < props.bauabschnitt; index++) {
      let input = props.bauabschnittDetails?.find(
        (item: any) => item.order === index + 1
      );

      if (input) {
        tempInputs.push({
          id: input.id,
          placeholder: input.name,
          value: input.name,
          order: index + 1,
          image: input.image,
        });
      } else {
        tempInputs.push({
          placeholder: `Part ${index + 1}`,
          value: "",
          order: index + 1,
        });
      }
    }
  }
  tempInputs.sort((a: any, b: any) => a.order - b.order);
  return tempInputs;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(__props.strings), 1),
        _cache[0] || (_cache[0] = _createElementVNode("p", null, "Strings", -1))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(__props.moduleFields), 1),
        _cache[1] || (_cache[1] = _createElementVNode("p", null, "Module field", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("p", _hoisted_9, _toDisplayString(__props.bauabschnitt), 1),
          _cache[2] || (_cache[2] = _createElementVNode("p", null, "Bauabschnitt", -1))
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (_unref(inputs))
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(inputs), (input) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: input.id,
                      class: "flex flex-col"
                    }, [
                      _createElementVNode("div", {
                        onClick: ($event: any) => (onOpenModal(input)),
                        class: _normalizeClass(["w-full flex items-center justify-between px-3 py-[10px] rounded-primary-radius hover:cursor-pointer transition-all duration-200 ease-in-out", 
                    !input.value
                      ? 'border border-[#ED857F] bg-transparent'
                      : 'border border-[#E3E1EA] bg-[#F9F8F6]'
                  ])
                      }, [
                        _createElementVNode("input", {
                          type: "text",
                          placeholder: input.placeholder,
                          value: input.value,
                          readonly: "",
                          class: "w-full outline-none text-base text-primary-text-color font-normal tracking-[0.01rem] bg-transparent placeholder:text-primary-text-color hover:cursor-pointer"
                        }, null, 8, _hoisted_14),
                        (input.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[3] || (_cache[3] = [
                              _createElementVNode("img", {
                                class: "w-5",
                                src: _imports_0,
                                alt: "Edit"
                              }, null, -1)
                            ]))]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_16, [...(_cache[4] || (_cache[4] = [
                              _createElementVNode("img", {
                                class: "w-5 h-5",
                                src: _imports_1,
                                alt: "Add"
                              }, null, -1)
                            ]))]))
                      ], 10, _hoisted_13),
                      (!input.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [...(_cache[5] || (_cache[5] = [
                            _createElementVNode("img", {
                              src: _imports_2,
                              alt: ""
                            }, null, -1),
                            _createElementVNode("span", { class: "text-sm text-[#ED857F]" }, "Title and image required", -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}
}

})